import {
    createPromocodeGroupsResource,
    deletePromocodeGroupsResource,
    getPromocodeGroupsResource,
    getPromocodeGroupsResources,
    updatePromocodeGroupsResource
} from "@/services/PromocodeGroupsService/PromocodeGroupsService.methods";

export const PromocodeGroupsService = {
    GetList: getPromocodeGroupsResources,
    Get: getPromocodeGroupsResource,
    Create: createPromocodeGroupsResource,
    Update: updatePromocodeGroupsResource,
    Delete: deletePromocodeGroupsResource,
};
